const ROLE_PANEL_PATHS = {
  customer: '/',
  vendor: '/vendor/dashboard',
  irancharsouq_admin: '/irancharsouq-admin',
  super_admin: '/super-admin/dashboard',
  inspector: '/inspector',
  company: '/company/dashboard',
};

export const getRolePanelPath = (role) => ROLE_PANEL_PATHS[role];
